export default "__VITE_ASSET__ByuncN1q__"